import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { GradingScheduleList } from '../../../../shared/interface/grading-schedule.interface';
import { ScheduleFormComponent } from './schedule-form/schedule-form.component';
import {ScheduleListComponent} from "./schedule-list/schedule-list.component";
import {ScheduleBatchProcessComponent} from "./schedule-batch-process/schedule-batch-process.component";

@Component({
    selector: 'app-registrar-admin-maintenance-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit {
    constructor() {}

    newCurrentDataSent: boolean = false;
    updateGradingSchedule: Array<GradingScheduleList>;
    formTermHasBeenLoaded: boolean = false;

    @ViewChild(ScheduleFormComponent) child: ScheduleFormComponent;
    @ViewChild(ScheduleListComponent) listChild: ScheduleListComponent;
    @ViewChild(ScheduleBatchProcessComponent) batchChild: ScheduleBatchProcessComponent;

    ngOnInit(): void {
        //
    }

    sendToEditForm($event) {
        this.child.updateCurrenFormEdit($event);
    }

    sendToList($event) {
        this.updateGradingSchedule = $event;
        this.batchChild.getAllOpenForGrading();
        this.updateScheduleList($event);
    }
    sendToListTermInfo($event) {
        this.formTermHasBeenLoaded = $event;
    }

    updateScheduleList($event){
        this.listChild.getScheduleList();
    }
}
